export const FADE_UP = { initial: { opacity: 0, y: 16 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.4 } };
export const FADE_UP_SLOW = { initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.5 } };
export const FADE_IN = { initial: { opacity: 0 }, animate: { opacity: 1 } };
export const EXPAND = { initial: { opacity: 0, height: 0 }, animate: { opacity: 1, height: "auto" } };
export const RISE_IN = { initial: { opacity: 0, y: 8 }, animate: { opacity: 1, y: 0 } };
